var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactsIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 31,
    viewBox: "0 0 42 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 27.3636C41 28.3673 40.1855 29.1818 39.1818 29.1818H2.81818C1.81455 29.1818 1 28.3673 1 27.3636V2.81818C1 1.81455 1.81455 1 2.81818 1H39.1818C40.1855 1 41 1.81455 41 2.81818V27.3636Z",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.272 3.72656L25.4993 16.4993C23.0147 18.9838 18.9847 18.9838 16.5002 16.4993L3.72656 3.72656",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72656 26.4551L13.7266 16.4551",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2734 26.4551L28.2734 16.4551",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsIcon4);
export default __webpack_public_path__ + "static/media/contacts-icon4.73dce9263f947bcfcccd060c25fd23cd.svg";
export { ForwardRef as ReactComponent };